import paths from "./paths";

const section = (label) => ({ id: `section-${label}`, label, section: true });

export const DEFAULT_TOP_NAV = [
  { id: "profile", label: "Profile", to: paths.profile, badge: null },
];

export const DEFAULT_BOTTOM_NAV = [
  { id: "settings", label: "Settings", to: paths.settings, badge: null },
  { id: "help-support", label: "Help & Support", to: paths.support, badge: null },
  { id: "legal", label: "Legal and Privacy", to: paths.legalPrivacy, badge: null },
];

const settingsSubNav = [
  { id: "settings-workspaces", label: "Manage Workspaces", to: paths.workspaces },
  { id: "settings-change-password", label: "Change Password", to: paths.settingsChangePassword },
  { id: "settings-security-questions", label: "Security Questions", to: paths.settingsSecurityQuestions },
  { id: "settings-verify-email", label: "Verify Email", to: paths.settingsVerifyEmail },
  { id: "settings-verify-phone", label: "Verify Phone", to: paths.settingsVerifyPhone },
  { id: "settings-app-details", label: "Olitask App Details", to: paths.settingsAppDetails },
  { id: "settings-supported-locations", label: "Supported Locations", to: paths.settingsSupportedLocations },
  { id: "settings-delete-account", label: "Deactivate or Delete Account", to: paths.settingsDeleteAccount },
  { id: "settings-notifications", label: "Notifications", to: paths.settingsNotifications },
  { id: "settings-language", label: "Language", to: paths.settingsLanguage },
  { id: "settings-theme", label: "Theme", to: paths.settingsTheme },
  { id: "settings-data-storage", label: "Data & Storage", to: paths.settingsDataStorage },
];

const isHelperUse = (value) => {
  const normalized = String(value || "").toUpperCase();
  return normalized === "HELPER" || normalized === "HIRING";
};

export const buildOlitaskNav = ({
  selectedWorkspace,
  selectedWorkspaceUse = "REQUESTER",
  canManageWorkspace = false,
  userId = "",
} = {}) => {
  const workspaceId = selectedWorkspace?.id || "";
  const hasWorkspace = Boolean(workspaceId);
  const isHelperWorkspace = isHelperUse(selectedWorkspaceUse);

  const topNav = [];

  if (hasWorkspace) {
    topNav.push(section("Tasks"));
    topNav.push({
      id: "tasks",
      label: isHelperWorkspace ? "Nearby Requests" : "My Requests",
      to: paths.myTasks,
      badge: null,
    });

    if (!isHelperWorkspace) {
      topNav.push({
        id: "create-request",
        label: "Create Request",
        to: paths.pmDashboard,
        badge: null,
      });
    }

    topNav.push(section("Accounts"));
    topNav.push(
      { id: "profile", label: "Account Profile", to: paths.profile, badge: null },
      {
        id: isHelperWorkspace ? "helper-profile" : "requester-profile",
        label: isHelperWorkspace ? "My Helper Profile" : "My Request Profile",
        to: userId
          ? isHelperWorkspace
            ? paths.helperProfileDetails(userId)
            : paths.requesterProfileDetails(userId)
          : paths.profile,
        badge: null,
      },
      {
        id: "professional-profiles",
        label: "Professional Profiles",
        to: paths.professionalProfiles,
        badge: null,
      },
      { id: "organizations", label: "Organizations", to: paths.organizations, badge: null },
      { id: "invitations", label: "Invitations", to: paths.invitations, badge: null },
    );

    if (canManageWorkspace) {
      topNav.push({
        id: "access-control",
        label: "Security & Access",
        to: paths.accessControl,
        badge: null,
      });
    }

  } else {
    topNav.push(section("Accounts"));
    topNav.push(
      { id: "profile", label: "Account Profile", to: paths.profile, badge: null },
    );
  }

  topNav.push(section("General"));
  topNav.push(
    { id: "settings", label: "Settings", to: paths.settings, badge: null, children: settingsSubNav },
  );

  topNav.push(
    { id: "inbox", label: "Inbox", to: paths.emailMessages, badge: null },
    { id: "help-support", label: "Help & Support", to: paths.support, badge: null },
    { id: "feedback", label: "Share Feedback", to: paths.feedback, badge: null },
    { id: "legal", label: "Legal and Privacy", to: paths.legalPrivacy, badge: null },
  );

  const bottomNav = [];

  if (hasWorkspace) {
    bottomNav.push(section("Payments & Credits"));
    bottomNav.push(
      {
        id: "wallet",
        label: "Wallet",
        to: paths.workspacePaymentMethods(workspaceId),
        badge: null,
      },
      {
        id: "charges",
        label: "Charges",
        to: paths.workspaceCharges(workspaceId),
        badge: null,
      },
    );

    if (isHelperWorkspace) {
      bottomNav.push({
        id: "earnings",
        label: "Earnings",
        to: paths.workspaceEarnings(workspaceId),
        badge: null,
      });
    }

    bottomNav.push(
      {
        id: "credits",
        label: "Credits",
        to: "",
        badge: "Soon",
        disabled: true,
      },
      {
        id: "donations",
        label: "Donations",
        to: "",
        badge: "Soon",
        disabled: true,
      },
    );
  }

  return { topNav, bottomNav };
};

export const buildOlreadiaNav = buildOlitaskNav;

export const TOP_NAV = DEFAULT_TOP_NAV;
export const BOTTOM_NAV = DEFAULT_BOTTOM_NAV;

export const FOOTER_NAV = [
  { id: "settings", label: "Settings", to: paths.settings },
  { id: "help-support", label: "Help & Support", to: paths.support },
];
